/**
 * « Photos de l'installation » : les photos de fin de chantier prises par le poseur (R5).
 *
 * Le serveur les sert deja filtrees (`photos_installation`, `modules/distributeur/
 * photos_installation.py`) : meme sous-compte, mandats qui couvrent un actif de la fiche,
 * sans aucun autre champ du mandat. Montrees dans la vue distributeur SEULEMENT
 * (decision de Boubacar du 26/10) : aucun ecran CRM ne les reprend.
 */
import { Camera } from 'lucide-react';
import GaleriePhotos from './GaleriePhotos';

export default function PhotosInstallation({ photos }) {
  const liste = Array.isArray(photos) ? photos : [];
  return (
    <div className="rounded-lg border border-neutral-200/80 bg-white p-5 space-y-3" data-testid="photos-installation">
      <h2 className="text-[14px] font-semibold text-neutral-900 flex items-center gap-2">
        <Camera className="w-4 h-4" /> Photos de l&apos;installation
      </h2>
      {liste.length === 0 ? (
        <p className="text-[12px] text-neutral-400" data-testid="photos-installation-vide">
          Aucune photo de l&apos;installation pour ce chantier.
        </p>
      ) : (
        <GaleriePhotos photos={liste.map((p, rang) => ({
          src: p.data_uri,
          libelle: `Photo de l'installation ${rang + 1}`,
          taken_at: p.taken_at,
          testid: `photo-installation-${rang}`,
        }))} />
      )}
    </div>
  );
}
